import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'MyAccount/listAvailable/ModalConfirm';

interface Props {
  isDisabled?: boolean;
}

export const Wrapper = styled.div`
  min-width: 290px;
  background: #f2f2f2;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.GRAY_DARK};
  border-radius: 16px;
  font-size: 13px;
  text-align: center;
  overflow: hidden;
  max-width: 320px;
  min-height: 140px;
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

export const Title = styled.h4`
  font-size: 17px;
  color: ${COLORS.BLACK_BOLD};
  margin: 20px auto 0;
  max-width: 194px;
`;

Title.displayName = `${ROOT}/Title`;

export const Detail = styled.p`
  margin: 10px auto 0;
  max-width: 212px;
`;

Detail.displayName = `${ROOT}/Detail`;

export const Actions = styled.div`
  margin-top: 20px;
  border-top: 1px solid rgba(0,0,0,.4);
  display: flex;
`;

Actions.displayName = `${ROOT}/Actions`;

const Button = `
  height: 60px;
  width: 50%;
  font-size: 17px;
`;

export const ButtonCancel = styled.button`
  ${Button}
  color: ${COLORS.BLUE_LINK};
  ${(props: Props) => props.isDisabled && `
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

ButtonCancel.displayName = `${ROOT}/ButtonCancel`;

export const ButtonDelete = styled.button`
  ${Button}
  color: ${COLORS.RED_HIGHLIGHT};
  border-left: 1px solid rgba(0,0,0,.4);
`;

ButtonDelete.displayName = `${ROOT}/ButtonDelete`;

export const LoaderWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

LoaderWrapper.displayName = `${ROOT}/LoaderWrapper`;
